import React, { useState, useEffect, useCallback } from 'react';
import { Banner, Button, Card, DataTable, Frame, Page, Toast, Modal, Tooltip, Badge, Link, Stack, Icon, List, TextContainer, DisplayText } from '@shopify/polaris';
import MarketForm from '../../components/MarketForm/index';
import { connect } from "react-redux";
import { getMarkets, createMarket, updateMarket, deleteMarket } from '../../redux/actions/marketActions';
import roundingApi from '../../services/roundingApi';
import productApi from '../../services/productsApi';
import marketApi from '../../services/marketApi';
import APIService from '../../services/APIService';
import { QuestionMarkMajor, CircleInformationMajor, EditMajor } from '@shopify/polaris-icons';
import { FormMode } from '../../helpers/constant';
import FrozeAdminPanel from '../FrozeAdminPanel';
import MCPFooterHelp from '../../components/common/MCPFooterHelp';
import CsvUploadJobBanner from '../../components/common/CsvUploadJobBanner';
import CsvDownloadJobBanner from '../../components/common/CsvDownloadJobBanner';
import CatalogPriceUpdateBanner from '../../components/common/CatalogPriceUpdateBanner';
import StoreAccessContainer from '../../containers/onboarding/StoreAccessContainer';
import Cookies from 'universal-cookie';
import { getOnboarding } from '../../redux/actions/onboardingActions';
import { refreshSettings } from '../../redux/actions/settingsActions';

const initialMarketForm = {
  regionName: '',
  displayCurrencyCodes: [],
  setCurrencyCode: '',
  inLocalCurrencies: false,
}
const MarketsContainer = props => {
  const { defaultCountryOptions, remainingMarketOptions, markets, isMarketLoading, getMarkets, getOnboarding, createMarket, updateMarket, deleteMarket, currencies, error, globalMarketOptions, shopPlan, storeDetails, onboarding } = props;
  const [isMarketFormOpen, setIsMarketFormOpen] = useState(false);
  const [marketForm, setMarketForm] = useState(initialMarketForm);
  const [moreActionActivator, setMoreActionActivator] = useState({});
  const [formMode, setFormMode] = useState(FormMode.ADD)
  const [isShowToast, setIsShowToast] = useState(false);
  const [isShowErrorToast, setIsShowErrorToast] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [toastMessage, setToastMessage] = useState("");
  const [isWarningModelOpen, setIsWarningModelOpen] = useState(false);
  const [tmpSetCurrency, setTmpSetCurrency] = useState(null);
  const [roundingRules, setRoundingRules] = useState([]);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [timer, setTimer] = useState(0);
  const [deleteMarketApiCalled, setDeleteMarketApiCalled] = useState(false);
  const [openFrozeAdminPanel, setOpenFrozeAdminPanel] = useState(false);
  const [onSaveApiCalled, setOnSaveApiCalled] = useState(false);
  const [setCurrencyOptions, setSetCurrencyOptions] = useState([]);
  const [setCurrencyApiCalled, setSetCurrencyApiCalled] = useState(false);
  const [defaultDisplayCurrencyOptions, setDefaultDisplayCurrencyOptions] = useState([]);
  const [displayCurrencyOptions, setDisplayCurrencyOptions] = useState([]);
  const [displayCurrencyApiCalled, setDisplayCurrencyApiCalled] = useState(false);
  const [displayCurrencyInputValue, setDisplayCurrencyInputValue] = useState('');
  const [managedBySPBanner, setManageBySpBanner] = useState(false);
  const [apiCalled, setApiCalled] = useState(true);
  const [ischeckoutSupporetedCurrenciesModalOpen, setIscheckoutSupporetedCurrenciesModalOpen] = useState(false);
  const [isContactUsModalOpen, setIsContactUsModalOpen] = useState(false);
  const [isCommonReasonsModalOpen, setIsCommonReasonsModalOpen] = useState(false);
  const [isBannerClosed, setIsBannerClosed] = useState(false);
  // const [marketLimitModalOpen, setMarketLimitModalOpen] = useState(false);

  // New state for status-based freeze
  // const [statusBasedFreezeActive, setStatusBasedFreezeActive] = useState(false);
  const [statusBasedTimer, setStatusBasedTimer] = useState(0);
  const [freezeType, setFreezeType] = useState('time');
  const [isFreezeFailed, setIsFreezeFailed] = useState(false);
  const [isFreezeFailedBy, setIsFreezeFailedBy] = useState('');
  const [fetchCount, setFetchCount] = useState(0);
  const [draftMarkets, setDraftMarkets] = useState([]);
  const [isDraftMarketsLoading, setIsDraftMarketsLoading] = useState(true);
  const [draftMarketTooltip, setDraftMarketTooltip] = useState({});

  // Modify the useEffect that calls checkOnboardingStatus:
  useEffect(() => {
    let isMounted = true;
    const init = async () => {
      if (markets.length === 0) {
        await getMarkets();
      }
      await fetchDraftMarkets();
      if (isMounted) {
        setApiCalled(false);
        if (onboarding && !openFrozeAdminPanel && fetchCount === 0) {
          setFetchCount(prev => prev + 1);
          await checkOnboardingStatus();
        }
      }
    };
    init();
    return () => { isMounted = false };
  }, [fetchCount]);
  const checkOnboardingStatus = useCallback(async () => {
    if (openFrozeAdminPanel) {
      return;
    }
    else {
      try {
        const BACKEND_END_POINT = process.env.REACT_APP_ADMIN_API_ENDPOINT;
        const response = await APIService.get(BACKEND_END_POINT + 'onboardings');
        if (response.status === 200 && response) {
          const { fetchProductsStatus, fetchMarketsStatus } = response.data;
          // if (fetchProductsStatus === 'failed' || fetchMarketsStatus === 'failed') {
          //   // await initializeStatusBasedFreeze();
          //   // setOpenFrozeAdminPanel(true);
          //   setIsFreezeFailed(true);
          // }
          if (fetchProductsStatus === 'failed') {
            setIsFreezeFailed(true);
            setIsFreezeFailedBy(response.data?.fetchProductsErrorMsg);
          } else if (fetchMarketsStatus === 'failed') {
            setIsFreezeFailed(true);
            setIsFreezeFailedBy(response.data?.fetchMarketsErrorMsg);
          }

          if (fetchProductsStatus !== 'completed' || fetchMarketsStatus !== 'completed') {
            await initializeStatusBasedFreeze();
          }
        }
        // if (onboarding && onboarding?.fetchProductsStatus && onboarding?.fetchMarketsStatus) {
        //   const { fetchProductsStatus, fetchMarketsStatus } = onboarding;

        //   if (fetchProductsStatus !== 'completed' || fetchMarketsStatus !== 'completed') {
        //     await initializeStatusBasedFreeze();
        //   }
        // } else {
        //   const BACKEND_END_POINT = process.env.REACT_APP_ADMIN_API_ENDPOINT;
        //   const response = await APIService.get(BACKEND_END_POINT + 'onboardings');
        //   if (response.status === 200 && response) {
        //     const { fetchProductsStatus, fetchMarketsStatus } = response.data;

        //     if (fetchProductsStatus !== 'completed' || fetchMarketsStatus !== 'completed') {
        //       await initializeStatusBasedFreeze();
        //     }
        //   }
        // }
      } catch (error) {
        console.error('Error checking onboarding status:', error);
      }
    }
  }, [onboarding?.fetchProductsStatus, onboarding?.fetchMarketsStatus, openFrozeAdminPanel]);

  // useEffect(() => {
  //   if (onboarding && !openFrozeAdminPanel) {
  //     checkOnboardingStatus();
  //   }
  // }, [onboarding?.fetchProductsStatus, onboarding?.fetchMarketsStatus, openFrozeAdminPanel]);

  const calculateTimerFromAPIs = async () => {
    // if (openFrozeAdminPanel) {
    //   return;
    // }
    try {
      const BACKEND_END_POINT = process.env.REACT_APP_ADMIN_API_ENDPOINT;

      // const productResponse = await APIService.get(BACKEND_END_POINT + 'productsCount');
      // const marketResponse = await APIService.get(BACKEND_END_POINT + 'marketsCount');
      const config = { headers: { 'Cache-Control': 'no-cache' } };
      const [productResponse, marketResponse] = await Promise.all([APIService.get(BACKEND_END_POINT + 'productsCount'), APIService.get(BACKEND_END_POINT + 'marketsCount')]);

      // console.log('current time with total time wait in seconds', productResponse, marketResponse);
      if (productResponse.status !== 200 || !productResponse.data?.count) {
        throw new Error(`Product count API failed: ${productResponse.status}`);
      }
      const productCount = parseInt(productResponse.data.count, 10);



      if (marketResponse.status !== 200 || !marketResponse.data?.count) {
        throw new Error(`Market count API failed: ${marketResponse.status}`);
      }
      const marketCount = parseInt(marketResponse.data.count, 10);

      if (isNaN(productCount) || isNaN(marketCount)) {
        throw new Error('Invalid count values from API');
      }

      const totalSeconds = productCount * marketCount;
      // console.log('current time with total time wait in seconds', new Date().toISOString(), productCount, marketCount, totalSeconds);

      return (totalSeconds * 250) > 250000 ? totalSeconds * 250 : 250000;
      // return totalSeconds * 250;
    } catch (error) {
      console.error('Error fetching counts:', error);
      return 30000;
    }
  };

  const initializeStatusBasedFreeze = async () => {
    if (openFrozeAdminPanel) {
      return;
    }
    try {
      const timerDuration = await calculateTimerFromAPIs();
      setStatusBasedTimer(timerDuration);
      setFreezeType('status');
      // setStatusBasedFreezeActive(true);
      setOpenFrozeAdminPanel(true);
    } catch (error) {
      console.error('Error initializing status-based freeze:', error);
      setStatusBasedTimer(30000);
      setFreezeType('status');
      // setStatusBasedFreezeActive(true);
      setOpenFrozeAdminPanel(true);
    }
  };

  const fetchRoundings = () => {
    roundingApi.getStoreRoundings().then(roundingRules => {
      setRoundingRules((roundingRules.data && roundingRules.data.rounding_rules) || []);
    });
  }

  const fetchDraftMarkets = async () => {
    try {
      setIsDraftMarketsLoading(true);
      const response = await marketApi.getDraftMarkets();
      if (response && response.data) {
        setDraftMarkets(response.data);
      }
    } catch (error) {
      console.error('Error fetching draft markets:', error);
      setDraftMarkets([]);
    } finally {
      setIsDraftMarketsLoading(false);
    }
  }

  const fetchSetCurrencies = async (regionName) => {
    setSetCurrencyApiCalled(true);
    const setCurrencies = await marketApi.getSetCurrencies(regionName);
    const tempCurrencies = [];
    for (let c of setCurrencies.data) {
      const currencyName = currencies.find(i => i.code === c);
      if (currencyName && currencyName.name) {
        tempCurrencies.push({ value: c, label: `${currencyName.name} (${c})` });
      } else {
        tempCurrencies.push({ value: c, label: c });
      }
    }
    setSetCurrencyOptions(tempCurrencies);
    if (tempCurrencies.length > 0) {
      setMarketForm((oldVal) => ({ ...oldVal, setCurrencyCode: tempCurrencies[0].value }));
    }
    setSetCurrencyApiCalled(false);
    return tempCurrencies;
  }

  const fetchDisplayCurrencies = async (regionName) => {
    setDisplayCurrencyApiCalled(true);
    setManageBySpBanner(false);
    const displayCurrencies = await marketApi.getDisplayCurrencies(regionName);
    const tempCurrencies = [];
    for (let c of displayCurrencies.data) {
      const currencyName = currencies.find(i => i.code === c);
      if (currencyName && currencyName.name) {
        tempCurrencies.push({ value: c, label: `${currencyName.name} (${c})` });
      } else {
        tempCurrencies.push({ value: c, label: c });
      }
    }
    if (formMode === FormMode.ADD && displayCurrencies.data && displayCurrencies.data.length > 0) {
      setMarketForm((oldVal) => ({ ...oldVal }));
    }
    setDisplayCurrencyOptions(tempCurrencies);
    setDefaultDisplayCurrencyOptions(tempCurrencies);
    if (displayCurrencies.data.length > 0) {
      const currencyFound = roundingRules.find(i => i.currency === displayCurrencies.data[0]);
      if (currencyFound && currencyFound.shopify_enabled) {
        setManageBySpBanner(true);
      }
    }
    setDisplayCurrencyApiCalled(false);
    return tempCurrencies;
  }

  const updateDisplayCurrencyText = useCallback((value) => {
    setDisplayCurrencyInputValue(value);

    if (value === '') {
      setDisplayCurrencyOptions(defaultDisplayCurrencyOptions);
      return;
    }

    const filterRegex = new RegExp(value, 'i');
    const resultOptions = defaultDisplayCurrencyOptions.filter((option) =>
      option.label.match(filterRegex),
    );
    let endIndex = resultOptions.length - 1;
    if (resultOptions.length === 0) {
      endIndex = 0;
    }
    setDisplayCurrencyOptions(resultOptions);
  },
    [defaultDisplayCurrencyOptions],
  );

  const handleFormStateChange = (key, val) => {
    if (key === "regionName") {
      const region = globalMarketOptions.find(i => i.regionName === val);
      if (region) {
        setMarketForm((oldVal) => ({ ...oldVal, regionType: region.regionType }));
      }
    }
    // *** SET SEEN IN AND SET IN CURRENCY SAME

    if (key === "setCurrencyCode" && storeDetails && storeDetails.isShopifyPaymentsEnabled) {
      setMarketForm((oldVal) => ({ ...oldVal, [key]: val }));
    }
    if (key === 'displayCurrencyCodes' && storeDetails && storeDetails.isShopifyPaymentsEnabled) {
      openModal(val[0])
    }
    else {
      setMarketForm((oldVal) => ({ ...oldVal, [key]: val }));
    }
    // *** SET SEEN IN AND SET IN CURRENCY SAME
    if (key === 'displayCurrencyCodes') {
      let managesBySP = false;
      for (let c of val) {
        const currencyFound = roundingRules.find(i => i.currency === c);
        if (currencyFound && currencyFound.shopify_enabled) {
          managesBySP = true;
          break;
        } else {
          managesBySP = false;
        }
      }
      setManageBySpBanner(managesBySP);
    }
    if (key === 'regionName') {
      fetchSetCurrencies(val);
      fetchDisplayCurrencies(val);
    }
    if (key === "inLocalCurrencies") {
      setMarketForm((oldVal) => ({ ...oldVal, [key]: val === "yes" ? true : false }));
    }
  }

  const removeDisplayCurrencies = useCallback(
    (tag) => () => {
      const options = [...marketForm.displayCurrencyCodes];
      options.splice(options.indexOf(tag), 1);
      let managesBySP = false;
      for (let c of options) {
        const currencyFound = roundingRules.find(i => i.currency === c);
        if (currencyFound && currencyFound.shopify_enabled) {
          managesBySP = true;
          break;
        } else {
          managesBySP = false;
        }
      }
      setManageBySpBanner(managesBySP);
      setMarketForm((oldVal) => ({ ...oldVal, displayCurrencyCodes: options }));
    },
    [marketForm.displayCurrencyCodes],
  );

  const closeModal = () => {
    setIsWarningModelOpen(false);
  }

  const handleCatalogPriceError = (message) => {
    setErrorMessage(message || 'Failed to update catalog prices.');
    setIsShowErrorToast(true);
  };

  const parseApiMessage = (data) => {
    if (!data) return null;
    if (typeof data === 'string') {
      try {
        return parseApiMessage(JSON.parse(data));
      } catch {
        return data;
      }
    }
    if (typeof data.message === 'string' && data.message.trim()) {
      return data.message;
    }
    return null;
  };

  const buildCatalogPricesBody = (adjustment) => {
    const shopifyMarketId = adjustment.marketId || adjustment.market_id;
    // Request body (array format per API spec)
    return [{
      marketId: String(shopifyMarketId),
      type: adjustment.type,
      operation: adjustment.operation,
      value: Number(adjustment.value),
      isComparePriceInclude: Boolean(adjustment.isComparePriceInclude),
      isPriceSetAccordingToPrimaryMarket: Boolean(adjustment.isPriceSetAccordingToPrimaryMarket),
      ...(adjustment.collectionIds
        ? {
          collectionIds: Array.isArray(adjustment.collectionIds)
            ? adjustment.collectionIds
            : adjustment.collectionIds
              .split(',')
              .map(id => id.trim())
              .filter(Boolean),
        }
        : {}),
    }];
  };

  const extractApiErrorMessage = (err, fallback) => {
    return (
      parseApiMessage(err?.error?.data) ||
      parseApiMessage(err?.response?.data) ||
      parseApiMessage(err?.data) ||
      (typeof err?.error?.error?.data === 'string' && err.error.error.data) ||
      (typeof err?.message === 'string' && err.message) ||
      fallback
    );
  };

  const openModal = (val) => {
    setTmpSetCurrency(val);
    setIsWarningModelOpen(true);
  }

  const handleSave = async (
    catalogAdjustment = null,
    shouldUpdateMarket = false,
  ) => {
    // Dispatch createMarket action to create new market
    // Then hide the form
    let res;
    let catalogUpdated = false;
    setOnSaveApiCalled(true);
    if (formMode === FormMode.ADD) {
      const marketFormClone = Object.assign({}, marketForm);
      const { displayCurrencyCodes, ...newMarketClone } = marketFormClone;
      // const displayCurrencyCodeValue = marketFormClone?.displayCurrencyCodes[0];

      // newMarketClone.displayCurrencyCode = displayCurrencyCodeValue;
      delete marketFormClone.isLoading;
      res = await createMarket(newMarketClone).catch(createMarketErr => {
        if (typeof createMarketErr?.error?.error?.data === "string") {
          setErrorMessage(createMarketErr.error.error.data);
        }
        setIsShowErrorToast(true);
        // setErrorMessage(createMarketErr.error.error.data);
      });

      await getMarkets();
    }
    else {
      // Market PUT is only needed when currency settings changed.
      if (shouldUpdateMarket) {
        const marketFormClone = Object.assign({}, marketForm);
        const { displayCurrencyCodes, ...newMarketClone } = marketFormClone;
        delete marketFormClone.isLoading;

        res = await updateMarket(newMarketClone).catch(updateMarketErr => {
          setErrorMessage(extractApiErrorMessage(updateMarketErr, 'Something went wrong!'));
          setIsShowErrorToast(true);
        });

        if (!res) {
          setOnSaveApiCalled(false);
          return;
        }
      }

      // When the adjustment checkbox is selected, also update catalog prices.
      if (catalogAdjustment) {
        try {
          const catalogPricesBody = buildCatalogPricesBody(catalogAdjustment);
          const catalogRes = await marketApi.updateCatalogPrices(catalogPricesBody);
          const catalogData = catalogRes?.data;
          if (catalogData && catalogData.success === false) {
            setErrorMessage(
              parseApiMessage(catalogData) || 'Failed to update catalog prices.'
            );
            setIsShowErrorToast(true);
            setOnSaveApiCalled(false);
            return;
          }
          catalogUpdated = true;

          props.refreshSettings();

          // Resync store-markets so catalogPriceAdjustments reflects on the form
          try {
            const marketsRes = await marketApi.getMarkets();
            const refreshedMarkets = Array.isArray(marketsRes?.data) ? marketsRes.data : [];
            const updatedMarket = refreshedMarkets.find(
              (m) =>
                m.id === marketForm.id ||
                m.market_id === marketForm.market_id ||
                m.market_id === catalogAdjustment.marketId
            );
            if (updatedMarket) {
              setMarketForm({ ...updatedMarket });
            }
            await getMarkets();
          } catch (syncErr) {
            console.error('Failed to resync markets after catalog price update:', syncErr);
          }
        } catch (catalogErr) {
          setErrorMessage(extractApiErrorMessage(catalogErr, 'Failed to update catalog prices.'));
          setIsShowErrorToast(true);
          setOnSaveApiCalled(false);
          return;
        }
      }

      if (!shouldUpdateMarket && !catalogAdjustment) {
        setOnSaveApiCalled(false);
        return;
      }
    }
    if (res || catalogUpdated) {
      // const roundings = {
      //   rounding_rules:[
      //     {currency:marketForm.setCurrencyCode}
      //   ]
      // };
      // for(const dc of marketForm.displayCurrencyCodes) {
      //   roundings.rounding_rules.push({currency: dc});
      // }
      // const roundingsRes = await roundingApi.updateStoreRoundings(roundings).catch(roundingErr => {
      //   setIsShowErrorToast(true);
      // });
      // if(roundingsRes) {
      //   setIsShowToast(true);
      // }
      setToastMessage(
        (formMode === FormMode.ADD)
          ? 'Market has been created successfully.'
          : catalogUpdated && !res
            ? 'Catalog prices updated successfully.'
            : 'Market has been updated successfully.'
      );
      setIsShowToast(true);
      setIsMarketFormOpen(false);
      setOnSaveApiCalled(false);
      try {
        const BACKEND_END_POINT = process.env.REACT_APP_ADMIN_API_ENDPOINT;
        const response = await APIService.get(BACKEND_END_POINT + 'onboardings');

        if (response.status === 200) {
          const { fetchProductsStatus, fetchMarketsStatus } = response.data;

          // if (fetchProductsStatus === 'failed' || fetchMarketsStatus === 'failed') {
          //   // await initializeStatusBasedFreeze();
          //   setIsFreezeFailed(true);
          // }
          if (fetchProductsStatus === 'failed') {
            setIsFreezeFailed(true);
            setIsFreezeFailedBy(response.data?.fetchProductsErrorMsg);
          } else if (fetchMarketsStatus === 'failed') {
            setIsFreezeFailed(true);
            setIsFreezeFailedBy(response.data?.fetchMarketsErrorMsg);

          }
          else if (fetchProductsStatus !== 'completed' || fetchMarketsStatus !== 'completed') {
            await initializeStatusBasedFreeze();
          }
        }
      } catch (error) {
        console.error('Post-save onboarding check failed:', error);
      }
    } else {
      setOnSaveApiCalled(false);
    }
  }

  const openConfirmationDelete = () => {
    productApi.getProductCount().then(countData => {
      const count = countData.data.count || 0;
      // setTimer(count * 2 * 1000);
      setTimer((count * 100) < 60000 ? 120000 : count * 100);
      setIsWarningModelOpen(false);
      setIsConfirmationModalOpen(true);
    }).catch(error => {
      if (error.error !== 'Invalid Session') {
        if (typeof error?.error === "string") {
          setErrorMessage(error.error);
        }
        setIsShowErrorToast(true);
      }
    })

  }

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
  }

  const handleDeleteRegion = async () => {
    setDeleteMarketApiCalled(true);
    setFormMode(FormMode.DELETE);
    await deleteMarket(marketForm);
    setIsShowToast(true);
    setIsMarketFormOpen(false);
    setDeleteMarketApiCalled(false);
    closeConfirmationModal();
    if (timer > 2000) {
      setFreezeType('time');
      setOpenFrozeAdminPanel(true);
    }
  }

  const closeFreezeAdminPanel = async () => {
    const cookies = new Cookies();
    cookies.remove(`${props.storeId}_mcp_freezeTime`, { path: '/' });


    setOpenFrozeAdminPanel(false);
    setIsFreezeFailed(false);

    // Force the onboarding status check after closing freeze panel
    try {
      const BACKEND_END_POINT = process.env.REACT_APP_ADMIN_API_ENDPOINT;
      const response = await APIService.get(BACKEND_END_POINT + 'onboardings');
      if (response.status === 200 && response) {
        const { fetchProductsStatus, fetchMarketsStatus } = response.data;
        // if (fetchProductsStatus === 'failed' || fetchMarketsStatus === 'failed') {
        //   setIsFreezeFailed(true);
        // }
        if (fetchProductsStatus === 'failed') {
          setIsFreezeFailed(true);
          setIsFreezeFailedBy(response.data?.fetchProductsErrorMsg);
        } else if (fetchMarketsStatus === 'failed') {
          setIsFreezeFailed(true);
          setIsFreezeFailedBy(response.data?.fetchMarketsErrorMsg);

        }
        else if (fetchProductsStatus !== 'completed' || fetchMarketsStatus !== 'completed') {
          // await initializeStatusBasedFreeze();
          try {
            const timerDuration = await calculateTimerFromAPIs();
            setStatusBasedTimer(timerDuration);
            setFreezeType('status');
            // setStatusBasedFreezeActive(true);
            setOpenFrozeAdminPanel(true);
          } catch (error) {
            console.error('Error initializing status-based freeze:', error);
            setStatusBasedTimer(30000);
            setFreezeType('status');
            // setStatusBasedFreezeActive(true);
            setOpenFrozeAdminPanel(true);
          }
        }
        else {
          window.location.reload();
        }
      }
    } catch (error) {
      console.error('Error checking onboarding status after closing freeze panel:', error);
    }

    // setStatusBasedFreezeActive(false);
    setFreezeType('time');
  }

  /**
   * Hide the more action menu for the rest of the markets expect selected
   */
  const toggleActive = (selectedMarket, toggleAction) => {
    setMoreActionActivator((oldVal) => {
      const tmpObject = {};
      markets.forEach((m) => {
        if (m.id !== selectedMarket.id || toggleAction === 'onClose')
          tmpObject[m.id] = false
        else
          tmpObject[selectedMarket.id] = !tmpObject[selectedMarket.id]
      })

      return tmpObject
    })
  }
  const handleImportedAction = () => {

  }

  const handleEditMarket = async (selectedMarket) => {
    selectedMarket.isLoading = true;
    setMoreActionActivator({ ...moreActionActivator, [selectedMarket.id]: false })
    const toBeUpdatedMarket = { ...markets.find((m) => m.id === selectedMarket.id) }
    let tempDisplayCurrencies;
    if (toBeUpdatedMarket.isPrimaryMarket && !isROWAvailable) {
      tempDisplayCurrencies = await fetchDisplayCurrencies("Rest of The World");
    } else {
      tempDisplayCurrencies = await fetchDisplayCurrencies(toBeUpdatedMarket.regionName);
    }
    setDisplayCurrencyInputValue('');
    const tempSetCurrencies = await fetchSetCurrencies(toBeUpdatedMarket.regionName, toBeUpdatedMarket.setCurrencyCode);
    const selectedSetCurrency = tempSetCurrencies.find(i => i.value === toBeUpdatedMarket.setCurrencyCode);
    if (!selectedSetCurrency) {
      toBeUpdatedMarket.setCurrencyCode = setCurrencyOptions.value;
    }

    // const selectedDisplayCurrency = [];
    // if(typeof toBeUpdatedMarket.displayCurrencyCodes ==="string"){
    //   const found = tempDisplayCurrencies.find(j => j.value === toBeUpdatedMarket.displayCurrencyCodes);
    //   if(found) {
    //     selectedDisplayCurrency.push(toBeUpdatedMarket.displayCurrencyCodes);
    //   }
    // }
    // else{
    //   for(let i of toBeUpdatedMarket.displayCurrencyCodes) {
    //     const found = tempDisplayCurrencies.find(j => j.value === i);
    //     if(found) {
    //       selectedDisplayCurrency.push(i);
    //     }
    //   }
    // }

    // toBeUpdatedMarket.displayCurrencyCodes = selectedDisplayCurrency;
    // console.log("toBeUpdatedMarket",toBeUpdatedMarket,112);
    // if(toBeUpdatedMarket.displayCurrencyCode && toBeUpdatedMarket.displayCurrencyCodes && toBeUpdatedMarket.displayCurrencyCodes.length==0){
    //   toBeUpdatedMarket.displayCurrencyCodes = [toBeUpdatedMarket.displayCurrencyCode]
    // }

    // if(!toBeUpdatedMarket.setCurrencyCode){
    //   const OldSetCurrencyCode = { ...markets.find((m) => m.id === selectedMarket.id) }.setCurrencyCode;
    //   if(OldSetCurrencyCode)toBeUpdatedMarket.setCurrencyCode = OldSetCurrencyCode;
    // }
    setMarketForm(toBeUpdatedMarket);
    setFormMode(FormMode.EDIT);
    setIsMarketFormOpen(true);
    selectedMarket.isLoading = false;
  }
  const openMarketForm = () => {
    setDisplayCurrencyInputValue('');
    setDisplayCurrencyOptions([]);
    setMarketForm({ ...initialMarketForm })
    setFormMode(FormMode.ADD)
    setIsMarketFormOpen(true)
  }

  // const getMoreActionMarkup = (market) => {
  //     return (
  //         <Popover

  //             active={moreActionActivator[market.id]}
  //             activator={
  //                 <Tooltip content="More actions" dismissOnMouseOut>
  //                     <Button onClick={(e) => { toggleActive(market) }}
  //                         plain
  //                         icon={MobileVerticalDotsMajor}></Button>
  //                 </Tooltip>}
  //             onClose={(e) => { toggleActive(market, 'onClose') }}
  //         >
  //             <ActionList
  //                 items={[
  //                     {
  //                         content: 'Edit',
  //                         onAction: () => { handleEditMarket(market) },
  //                     },
  //                     {
  //                         content: 'Edit prices',
  //                         onAction: () => { props.history.push("/app/product-prices") },
  //                     },
  //                     // {
  //                     //     content: 'Delete',
  //                     //     onAction: () => { handleEditMarket(market) },
  //                     // },
  //                 ]}
  //             />
  //         </Popover>)
  // }

  const getMoreActionMarkup = (market) => {
    return (
      <Button plain loading={market.isLoading} disabled={market.isLoading} onClick={() => { handleEditMarket(market) }}>Settings</Button>
    )
  }

  const getBadge = (market) => {
    let isROWAvailable = false;
    for (let m of markets) {
      if (m?.regionCode === "intl" || m?.fixedName?.toLowerCase() === "international" || m?.regionName?.toLowerCase() === "international") {
        isROWAvailable = true;
        break;
      }
    }
    return (
      <span>
        <span className="cursor-pointer" onClick={() => { props.history.push("/app/product-prices"); }}>{market.regionName}{!isROWAvailable && market.isPrimaryMarket && <span> + International</span>}</span>
        {market.isPrimaryMarket && <span className="ml-10 cursor-pointer">
          <Tooltip content="Primary market represents the location(s) that you choose to keep selling at the prices before you installed our app.">
            <Badge status="success">Primary</Badge>
          </Tooltip>
        </span>}
      </span>
    )
  }

  const getSetCurrencyTextBox = (setCurrencyCode) => {

    // const setCurrencyName = currencies.find(i => i.code === setCurrencyCode);
    return (
      <div className="textField" title={setCurrencyCode}>{setCurrencyCode}</div>
    )
  }

  const getDraftMarketInfoIcon = () => {
    return (
      <Tooltip content="Currently this market is in draft state at your Shopify store admin" dismissOnMouseOut preferredPosition="below" >
        <span style={{ display: 'inline-block', maxWidth: '16px', maxHeight: '16px' }}>
          <Icon source={CircleInformationMajor} color="base" fontSize="small" style={{ maxWidth: '16px', maxHeight: '16px' }} />
        </span>
      </Tooltip>
    )
  }

  useEffect(() => {
    if (markets.length > 0) {
      setMoreActionActivator((oldVal) => {
        const tmpObject = {}
        markets.forEach((m) => {
          tmpObject[m.id] = false;
          m.isLoading = false;
        })
        return tmpObject
      })
    }
  }, [markets]);

  useEffect(() => {
    if (error && error.error) {
      if (error.error !== "Invalid Session") {
        if (typeof error?.error === "string") {
          setErrorMessage(error.error);
        }
        setIsShowErrorToast(true);
      }
    }
  }, [error])

  // useEffect(() => {
  //   if (markets.length === 0) {
  //     getMarkets().then(() => {
  //       setApiCalled(false);
  //     });
  //   } else {
  //     setApiCalled(false);
  //   }
  //   // // fetchRoundings();
  //   // checkOnboardingStatus();
  //   if (!openFrozeAdminPanel) {
  //     checkOnboardingStatus();
  //   }
  // }, [])

  //     const getDisplayCurrencyTextBox = (displayCurrencyCodes) => {
  //       // const displayCurrencies = [];
  //       // for(let c of displayCurrencyCodes) {
  //       //   const displayCurrencyName = currencies.find(i => i.code === c);
  //       //   if(displayCurrencyName && displayCurrencyName.name) {
  //       //     displayCurrencies.push(displayCurrencyName.name);
  //       //   }
  //       // }
  //       const supportedCurrencies = [];
  //       if(typeof displayCurrencyCodes=="string"){
  //         if(props.supportedCheckoutCurrencies.indexOf(displayCurrencyCodes) >= 0) {
  //             supportedCurrencies.push(displayCurrencyCodes); 
  //         }
  //       }
  //       else{
  //         for(let c of displayCurrencyCodes) {
  //           if(props.supportedCheckoutCurrencies.indexOf(c) >= 0) {
  //             supportedCurrencies.push(c);
  //           }
  //         }
  //       }
  //       return (
  //         <div className="displayCurrencyInTable">
  //           {typeof displayCurrencyCodes=="string" ?          
  //           <div className="textField" title={displayCurrencyCodes}>{displayCurrencyCodes}</div> :
  //           <div className="textField" title={displayCurrencyCodes.join(", ")}>{displayCurrencyCodes.join(", ")}</div>
  // }
  //           <span className="tooltipSpan">
  //             <Tooltip content={supportedCurrencies.length > 0 ? 
  //               (supportedCurrencies.length === 1 ? 
  //                 `As per your checkout and payment gateway settings, customers browsing website in ${supportedCurrencies.join(', ')} can pay directly.` 
  //                 : `As per your checkout and payment gateway settings, customers browsing website in ${supportedCurrencies.join(', ')} can pay directly. Others will pay in your store currency.`) : 
  //               `As per your checkout and payment gateway settings, customers can only pay in your store currency.`}>
  //               <Icon source={QuestionMarkMajor} color="base" />
  //             </Tooltip>
  //           </span>
  //         </div>
  //       )
  //     }

  // const marketRows = markets.map((m, index) => [index + 1, getBadge(m), getSetCurrencyTextBox(m.setCurrencyCode), getDisplayCurrencyTextBox(m.displayCurrencyCodes), getMoreActionMarkup(m)])
  const marketRows = markets.map((m, index) => [index + 1, getBadge(m), getSetCurrencyTextBox(m.setCurrencyCode), getMoreActionMarkup(m)])
  const draftMarketRows = draftMarkets.map((dm, index) => [index + 1, dm.name || dm.regionName || 'Draft Market'])

  let isROWAvailable = false;
  for (let m of markets) {
    if (m.regionCode === "intl") {
      isROWAvailable = true;
      break;
    }
  }

  const handleCatalogStatusCheckResult = useCallback((message, isError) => {
    if (isError) {
      setErrorMessage(message);
      setIsShowErrorToast(true);
    } else {
      setToastMessage(message);
      setIsShowToast(true);
    }
  }, []);

  return (
    <div className="market-container">
      <CsvUploadJobBanner isCsvUploadJobRunning={props.isCsvUploadJobRunning} />
      <CsvDownloadJobBanner />
      <CatalogPriceUpdateBanner onStatusCheckResult={handleCatalogStatusCheckResult} />
      {!isBannerClosed && <div className="marketContactUsBanner">
        <Banner status="critical" title="Important Information" onDismiss={() => { setIsBannerClosed(true) }}>
          <p>Please test the app after setting prices for any <span className='bold-font'>one product</span> from the Prices tab above (<Link url='https://youtu.be/vBpIU1Df2Pg?start=123' external>Refer this video</Link>). Common <Link onClick={() => setIsCommonReasonsModalOpen(true)}>reasons</Link> for issues. <Link onClick={() => setIsContactUsModalOpen(true)}>Give us access</Link> if you find any issue with our app.</p>
        </Banner>
      </div>}
      <Page
        title="Your Active Markets"
        primaryAction={{
          content: '+ Create Market',
          onAction: () => {/*  SHOW LIMIT EXCEEDS MARKET FORM ACCORDING TO STORE PLAN */
            console.log(markets.length);
            openMarketForm()
            // if ((markets.length >= 3 && !shopPlan?.toLowerCase().includes("plus")) || (markets.length == 50)) { setMarketLimitModalOpen(true) }
            // else {
            //   console.log(markets.length); openMarketForm()
            // }
          }
        }}
      >

        {!apiCalled && <Card>
          <DataTable
            columnContentTypes={[
              'text',
              'text',
              'text',
              'text',
            ]}
            headings={[
              'No.',
              'Target market',
              'Prices set in',
              ''
            ]}
            rows={marketRows}

          />
        </Card>}
        <br />

        {/* Draft Markets Section */}
        {!isDraftMarketsLoading && draftMarkets.length > 0 && (
          <div className="draft-markets-section" style={{ marginTop: '20px', marginBottom: '20px' }}>
            <p className="Polaris-Heading" style={{ marginBottom: '15px', fontSize: '22px', fontWeight: '400' }}>Your Draft Markets {getDraftMarketInfoIcon()}</p>
            <Card>
              <div style={{ backgroundColor: '#fff5f5' }}>
                <DataTable
                  columnContentTypes={[
                    'text',
                    'text',
                  ]}
                  headings={[
                    'No.',
                    'Market name',
                  ]}
                  rows={draftMarketRows}
                />
              </div>
            </Card>
          </div>
        )}

        <div className="marketBanner">
          <Banner>
            <p>As per your checkout and payment gateway settings, customers browsing website in <Link onClick={() => setIscheckoutSupporetedCurrenciesModalOpen(true)}>these currencies</Link> can pay directly. Others will pay in your store currency. Please contact <a rel="noreferrer noopener" aria-label=" (opens in a new tab)" href="mailto:support@mlveda.com" target="_blank"><span className="emailLink">support@mlveda.com</span></a> for more details.</p>
          </Banner>
        </div>
        {/* {!isROWAvailable && <div className="mt-10 restOfWorldMessage"><span>* Prices of rest of the world will be same as primary market</span><Tooltip content={`If you want to set up different prices for rest of the world then create a new market and choose "Rest of The World" from the country/continent dropdown.`}>
                    <Icon source={CircleInformationMajor} color="base" />
                  </Tooltip> </div>} */}
        <MCPFooterHelp />
      </Page>

      {isMarketFormOpen && <MarketForm
        marketForm={marketForm}
        onFormStateChange={handleFormStateChange}
        defaultCountryOptions={formMode === FormMode.EDIT ? defaultCountryOptions : remainingMarketOptions}
        onSave={handleSave}
        handleDeleteRegion={handleDeleteRegion}
        formMode={formMode}
        onCloseForm={() => { setFormMode(FormMode.ADD); setIsMarketFormOpen(false) }}
        isWarningModelOpen={isWarningModelOpen}
        openModal={openModal}
        closeModal={closeModal}
        tmpSetCurrency={tmpSetCurrency}
        openConfirmationDelete={openConfirmationDelete}
        isConfirmationModalOpen={isConfirmationModalOpen}
        timer={timer}
        closeConfirmationModal={closeConfirmationModal}
        deleteMarketApiCalled={deleteMarketApiCalled}
        onSaveApiCalled={onSaveApiCalled}
        setCurrencyApiCalled={setCurrencyApiCalled}
        setCurrencyOptions={setCurrencyOptions}
        displayCurrencyApiCalled={displayCurrencyApiCalled}
        displayCurrencyOptions={displayCurrencyOptions}
        updateDisplayCurrencyText={updateDisplayCurrencyText}
        displayCurrencyInputValue={displayCurrencyInputValue}
        removeDisplayCurrencies={removeDisplayCurrencies}
        managedBySPBanner={managedBySPBanner}
        supportedCheckoutCurrencies={props.supportedCheckoutCurrencies}
        isROWAvailable={isROWAvailable}
        onCatalogPriceError={handleCatalogPriceError}
        catalogPriceUpdateRunningMarkets={props.catalogPriceUpdateRunningMarkets}
      />}
      {/* {console.log('----------------------------------')} */}
      {/* Enhanced FrozeAdminPanel with status monitoring - SINGLE INSTANCE */}
      {/* {openFrozeAdminPanel && (
        <FrozeAdminPanel
          timeInMs={freezeType === 'status' ? statusBasedTimer : timer}
          enableStatusMonitoring={freezeType === 'status'}
          closeFreezeAdminPanel={closeFreezeAdminPanel}
          storeId={props.storeId}
        />
      )} */}
      {(openFrozeAdminPanel || isFreezeFailed) && (
        <FrozeAdminPanel
          timeInMs={freezeType === 'status' ? statusBasedTimer : timer}
          enableStatusMonitoring={freezeType === 'status'}
          closeFreezeAdminPanel={closeFreezeAdminPanel}
          storeId={props.storeId}
          isFailureMode={isFreezeFailed}
          isFailureModeBy={isFreezeFailedBy}
        />
      )}
      {/* {openFrozeAdminPanel && <FrozeAdminPanel timeInMs={timer} closeFreezeAdminPanel={closeFreezeAdminPanel} storeId={props.storeId} />} */}
      {isShowToast && <Frame>
        <Toast
          duration={2000}
          content={toastMessage || ((formMode === FormMode.ADD) ? 'Market has been created successfully.' : (formMode === FormMode.EDIT ? 'Market has been updated successfully.' : 'Market has been deleted successfully.'))}
          onDismiss={() => { setIsShowToast(false); setToastMessage(""); }} />
      </Frame>}

      {isShowErrorToast && <Frame>
        <Toast
          error
          duration={1500}
          content={!!errorMessage ? errorMessage : "Something went wrong!"}
          onDismiss={() => { setIsShowErrorToast(false) }} />
      </Frame>}

      <Modal
        large={true}
        title="Checkout supported currencies"
        open={ischeckoutSupporetedCurrenciesModalOpen}
        primaryAction={{
          content: "Close",
          onAction: () => setIscheckoutSupporetedCurrenciesModalOpen(false)
        }}
      >
        <Modal.Section>
          <div className="supportCheckoutCurrencies">
            <Stack distribution="fillEvenly">
              {props.supportedCheckoutCurrencies.map((currency) => {
                const currencyName = props.currencies.find(i => i.code === currency);
                return (
                  <Stack.Item key={currency}>{currencyName ? currencyName.name : ""}{currencyName ? " (" + currency + ")" : " " + currency}</Stack.Item>
                )
              })}
            </Stack>
            <p className="mt-15"><span className="bold-font">Note:</span> Others will pay in your store currency. Please write to us at <a rel="noreferrer noopener" aria-label=" (opens in a new tab)" href="mailto:support@mlveda.com" target="_blank"><span className="emailLink">support@mlveda.com</span></a> if you have any queries.</p>
          </div>
        </Modal.Section>
      </Modal>

      <Modal
        title="Give us access"
        open={isContactUsModalOpen}
      >
        <Modal.Section>
          <StoreAccessContainer setIsContactUsModalOpen={setIsContactUsModalOpen} />
        </Modal.Section>
      </Modal>

      <Modal
        title="Common reasons for issues"
        open={isCommonReasonsModalOpen}
        primaryAction={{
          content: "OK",
          onAction: () => setIsCommonReasonsModalOpen(false)
        }}
      >
        <Modal.Section>
          <List type='number'>
            <List.Item>Some apps on your store may be conflicting with our app.</List.Item>
            <List.Item>Customizations done on your theme may be conflicting with our app.</List.Item>
            <List.Item>Our app <Link url={`https://${props.storeId}/${process.env.REACT_APP_EXTENSION_URL}`}
              external>Embed Block</Link> may have been disabled on your theme.</List.Item>
          </List>
        </Modal.Section>
      </Modal>
      {/* <Modal title="Reached number of markets for your store" open={marketLimitModalOpen} primaryAction={{
        content: "OK",
        onAction: () => setMarketLimitModalOpen(false)
      }} >
        <Modal.Section>
          <TextContainer >
            <p>Can not create more markets for your store</p>
          </TextContainer>
        </Modal.Section>
      </Modal> */}
    </div>
  );
};


const mapStateToProps = (state) => {
  const { globalMarketOptions, countryOptions } = state.globalMarkets

  const storeMarketsRegionNames = state.markets.markets.map((m) => m.regionName.toLowerCase())
  const remainingMarketOptions = countryOptions.filter((mo) => !storeMarketsRegionNames.includes(mo.value.toLowerCase()))
  return {
    isMarketLoading: state.markets.isLoading,
    markets: state.markets.markets,
    error: state.markets.error,
    onboarding: state.onboarding.onboarding,
    globalMarketOptions,
    defaultCountryOptions: countryOptions,
    currencies: state.currencies.currencies,
    remainingMarketOptions,
    storeId: state.auth && state.auth.storeDetails && state.auth.storeDetails.myshopify_domain,
    supportedCheckoutCurrencies: state.auth && state.auth.storeDetails && state.auth.storeDetails.enabled_presentment_currencies,
    shopPlan: state.auth && state.auth.storeDetails && state.auth.storeDetails.shopPlan,
    storeDetails: state.auth && state.auth.storeDetails,
    isCsvUploadJobRunning: Boolean(state.settings.isCsvUploadJobRunning),
    catalogPriceUpdateRunningMarkets:
      state.settings.catalogPriceUpdateRunningMarkets || [],
  }
}
const mapDispatchToProps = {
  getMarkets,
  createMarket,
  updateMarket,
  deleteMarket,
  getOnboarding,
  refreshSettings,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MarketsContainer);
